module.exports = __webpack_public_path__ + "img/nes1.3599b072.png";